package nl.volleyplanner.web.controller.thuisprogramma

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import nl.volleyplanner.web.base.HTMLComponent
import nl.volleyplanner.web.lib.Dropdown
import nl.volleyplanner.web.util.BootstrapBreakPoint
import nl.volleyplanner.web.util.BootstrapUtil
import org.w3c.dom.HTMLElement

data class ToolbarItem(
    val itemHtmlId: String,
    val buttonContent: FlowContent.() -> Unit,
    val itemContent: FlowContent.() -> Unit
)

class Toolbar(private val toolbarItems: List<ToolbarItem>) : HTMLComponent() {
    override fun render(consumer: TagConsumer<HTMLElement>): HTMLElement {
        return consumer.div (classes = "vp-toolbar row p-0 d-print-none bg-secondary-subtle") {
            val dropdownCssClass = when (BootstrapUtil.getCurrentBreakpoint()) {
                BootstrapBreakPoint.XS -> "dropup"
                BootstrapBreakPoint.SM -> "dropup"
                BootstrapBreakPoint.MD -> "dropend"
                else -> "dropdown"
            }
            toolbarItems.forEach { item ->
                div(classes = "col p-0 vp-toolbar-item") {
                    classes += dropdownCssClass
                    button (classes = "dropdown-toggle") {
                        id = item.itemHtmlId
                        attributes["data-bs-toggle"] = "dropdown"

                        onClickFunction = { event ->
                            // Somehow Bootstrap cannot handle the dropdown itself
                            // Dropdown immediately hides after showing. So need to manually control for now
                            event.preventDefault()
                            // Get element by ID instead of using event target. The target could be an other element within
                            Dropdown.getOrCreateInstance(document.getElementById(item.itemHtmlId)!!)
                                .toggle()
                            event.stopPropagation()
                        }

                        item.buttonContent(this)
                    }
                    div(classes = "dropdown-menu p-2") {
                        item.itemContent(this)
                    }
                }
            }
        }
    }

    override suspend fun getState() = null
}